
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import get from 'lodash/get';
import * as prismic from '@prismicio/client';
import { NextPage, NextPageContext } from 'next';

import { PageProps } from 'types/pages';
import { formatDateForQuery } from 'helpers/date';

import { fetchTagesplanData } from 'pages/api/tagesplanApi';
import { getDocumentRelationsFromFile } from 'prismic/getDocumentRelations';
import { LOCALES, LOCALES_MAP, PRISMIC_CUSTOM_TYPES } from 'prismic/config';
import { client, fetchDocuments, fetchSharedData } from 'prismic/helpers/fetchContent';

import { ApiFetchTagesplanResponse } from 'pages/api/tagesplanApi.types';

import { OverviewTagesPlan } from 'components/organisms/OverviewTagesPlan';
import TemplateWrapper from 'components/templates/partials/TemplateWrapper';
import PageBackground from 'components/atoms/PageBackground/PageBackground';
import Header from 'components/organisms/Header/Header';
import { Footer } from 'components/organisms/Footer';
import { HeaderSpacer } from 'components/atoms/HeaderSpacer';

const { page, header, footer } = PRISMIC_CUSTOM_TYPES;

/* ---------------------------------------------
 * Types
 * --------------------------------------------- */

export interface TagesPlanOverviewProps extends PageProps {
  events: ApiFetchTagesplanResponse | null;
}

/* ---------------------------------------------
 * Page
 * --------------------------------------------- */

const TagesPlanOverview: NextPage<TagesPlanOverviewProps> = ({
  header,
  data,
  footer,
  events,
}) => {
  const { alternate_languages } = data;

  return (
    <TemplateWrapper pageId={data.id} data={data}>
      <PageBackground />
      <Header {...header} alternateLanguages={alternate_languages} />
      <HeaderSpacer />
      <OverviewTagesPlan data={data} events={events} />
      <Footer data={get(footer, 'data.body', [])} />
    </TemplateWrapper>
  );
};

/* ---------------------------------------------
 * SSR
 * --------------------------------------------- */

 async function _getServerSideProps(context: NextPageContext) {
  const { domain } = context.query;
  const localePrefix = context.locale;

  const currentDomain =
    (domain && (typeof domain === 'string' ? domain : domain[0])) || 'ballenberg.ch';

  const locale =
    (localePrefix && (typeof localePrefix === 'string'
      ? localePrefix
      : localePrefix[0])) ?? LOCALES.default;

  const lang = LOCALES_MAP[locale];

  const sharedData = await fetchSharedData(lang);
  const documentRelations = await getDocumentRelationsFromFile();

  /* Page content */
  const documents = await fetchDocuments({
    pageType: 'tagesplan_uebersicht',
    lang,
  });

  const fetchedContent = documents.length > 0 ? documents[0] : null;

  if (!fetchedContent) {
    return { notFound: true };
  }

  
  /* Header & Footer — retry once on failure (Prismic ref rotation) */
  let headerData = null;
  let footerData = null;
  for (let attempt = 0; attempt < 2; attempt++) {
    try {
      [headerData, footerData] = await Promise.all([
        client.getFirst({
          lang,
          predicates: [
            prismic.predicate.at('document.tags', [currentDomain]),
            prismic.predicate.at('document.type', header),
          ],
        }),
        client.getFirst({
          lang,
          predicates: [
            prismic.predicate.at('document.tags', [currentDomain]),
            prismic.predicate.at('document.type', footer),
          ],
        }),
      ]);
      break;
    } catch (error) {
      console.error(`[Tagesplan] header/footer fetch error (attempt ${attempt + 1})`, error);
      if (attempt === 0) await new Promise((r) => setTimeout(r, 500));
    }
  }

  const fetchedContentHeaderFooter = {
    header: headerData,
    footer: footerData,
    domain: currentDomain,
    type: page,
  };

  /* ---------------------------------------------
   * Fetch Tagesplan (BACKEND AS-IS ✅)
   * --------------------------------------------- */

  let eventsData: ApiFetchTagesplanResponse | null = null;

  try {
    const dateParam = context.query?.date ?? formatDateForQuery(new Date());
    const dateStr = Array.isArray(dateParam) ? dateParam[0] : dateParam;

    const resp = await fetchTagesplanData(
      { lang, date: dateStr },
      currentDomain
    );

    eventsData = resp as any;
  } catch (error) {
    console.error('[Tagesplan] fetch events error', error);
  }

  const safeEventsData: ApiFetchTagesplanResponse = eventsData ?? {
    tagesplanUid: null,
    termineUid: null,
    schedule: [],
  };

  return {
    props: {
      data: { ...fetchedContent },
      ...fetchedContentHeaderFooter,
      sharedData,
      documentRelations,
      events: safeEventsData,
    } as TagesPlanOverviewProps,
  };
}

export default TagesPlanOverview;


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/[domain]/tagesplan/index',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  